"use client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Carousel } from "react-bootstrap";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

export default function CustomCarousel({ imgs, proxy }) {
  return (
    <Carousel
      interval={2000}
      controls={true}
      indicators={false}
      prevLabel={null}
      nextLabel={null}
      prevIcon={
        imgs &&
        imgs.length > 1 && (
          <span>
            <FontAwesomeIcon icon={faChevronLeft} size="2x" color="black" />
          </span>
        )
      }
      nextIcon={
        imgs &&
        imgs.length > 1 && (
          <span>
            <FontAwesomeIcon icon={faChevronRight} size="2x" color="black" />
          </span>
        )
      }
    >
      {imgs?.map((img, index) => (
        <Carousel.Item key={index}>
          <img
            // className={styles.carousel_item}
            src={proxy() + img}
            alt={"img"}
            style={{
              width: "100%",
              height: " 400px",
              objectFit: "contain",
              display: "block",
            }}
            loading="lazy"
            onError={(e) => {
              if (e.target.src !== proxy + "/images/icon/file-unknown.svg") {
                e.target.src = "/images/icon/file-unknown.svg";
              }
            }}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
}
